import {canUseGlobalCountryScope} from "../api/countryScope";

const positiveId = (value) => {
    const normalized = String(value ?? "").trim();
    return /^[1-9]\d*$/.test(normalized) ? normalized : null;
};

const canOperateSelectedCountry = (canSelectCountry) => {
    if (typeof canSelectCountry === "boolean") return canSelectCountry;
    return canUseGlobalCountryScope(localStorage.getItem("role"));
};

export const isActorCountryScope = ({countryScope, actorCountryId, canSelectCountry} = {}) => {
    const scope = positiveId(countryScope);
    if (scope === null) return false;
    if (canOperateSelectedCountry(canSelectCountry)) return true;
    const actor = positiveId(actorCountryId);
    return actor !== null && scope === actor;
};

export const getActorCountryScopeBlock = ({countryScope, actorCountryId, canSelectCountry} = {}) => {
    if (isActorCountryScope({countryScope, actorCountryId, canSelectCountry})) return null;

    if (String(countryScope ?? "") === "0") {
        return {
            title: "Выберите страну учетной записи",
            copy: "Эта операция выполняется в tenant оператора и недоступна для глобального контура.",
        };
    }

    return {
        title: "Операция недоступна для выбранной страны",
        copy: "Backend определяет tenant по учетной записи оператора. Переключитесь на страну учетной записи, чтобы исключить операцию в неверном контуре.",
    };
};

export const requireActorCountryScope = ({countryScope, actorCountryId, canSelectCountry} = {}) => {
    if (!isActorCountryScope({countryScope, actorCountryId, canSelectCountry})) {
        throw new Error("Операция разрешена только в стране учетной записи оператора");
    }
    return String(countryScope).trim();
};
